import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CHECKOUT_URL } from './data';
import { ShieldCheck, Lock, Check, BookOpen, Gift, Users } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section id="compra" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-85">
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-zinc-900 to-zinc-950" data-id="element-86" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-96 bg-amber-400/10 blur-[100px] rounded-full pointer-events-none" data-id="element-87" />

      <div className="relative max-w-3xl mx-auto bg-zinc-900/80 backdrop-blur-md border border-amber-400/20 rounded-3xl p-6 sm:p-8 md:p-12 shadow-2xl" data-id="element-88">
        {/* Countdown */}
        <div className="mb-8 text-center" data-id="element-89">
          <p className="text-red-400 font-bold uppercase tracking-wider text-sm mb-3" data-id="element-90">
            La oferta expira en:
          </p>
          <div className="flex justify-center gap-4 text-white font-display text-4xl md:text-5xl" data-id="element-91">
            <div className="flex flex-col items-center" data-id="element-92">
              <span className="bg-zinc-950 px-4 py-2 rounded-lg border border-zinc-800" data-id="element-93">
                {formatTime(timeLeft.hours)}
              </span>
              <span className="text-xs text-zinc-500 mt-2" data-id="element-94">HORAS</span>
            </div>
            <span className="py-2" data-id="element-95">:</span>
            <div className="flex flex-col items-center" data-id="element-96">
              <span className="bg-zinc-950 px-4 py-2 rounded-lg border border-zinc-800" data-id="element-97">
                {formatTime(timeLeft.minutes)}
              </span>
              <span className="text-xs text-zinc-500 mt-2" data-id="element-98">MIN</span>
            </div>
            <span className="py-2" data-id="element-99">:</span>
            <div className="flex flex-col items-center" data-id="element-100">
              <span className="bg-zinc-950 px-4 py-2 rounded-lg border border-zinc-800 text-amber-400" data-id="element-101">
                {formatTime(timeLeft.seconds)}
              </span>
              <span className="text-xs text-zinc-500 mt-2" data-id="element-102">SEG</span>
            </div>
          </div>
        </div>

        {/* Cupos disponibles */}
        <div className="mb-8" data-id="element-103">
          <div className="flex items-center justify-between mb-2" data-id="element-104">
            <span className="flex items-center gap-2 text-zinc-300 text-sm font-medium" data-id="element-105">
              <Users className="w-4 h-4 text-amber-400" data-id="element-106" />
              Cupos a este precio
            </span>
            <span className="text-amber-400 font-display font-bold" data-id="element-107">
              ¡Solo quedan 270 cupos libres!
            </span>
          </div>
          <div className="w-full h-4 bg-zinc-950 border border-zinc-800 rounded-full overflow-hidden" data-id="element-108">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '91%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} className="h-full bg-amber-400 rounded-full" data-id="element-109" />
          </div>
          <p className="text-xs text-zinc-500 mt-2 text-right" data-id="element-110">
            91% de los cupos ya fueron tomados
          </p>
        </div>

        {/* Value stack */}
        <div className="mb-8 text-center" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-2" data-id="element-112">
            Hoy te llevás todo esto
          </h2>
          <p className="text-amber-400 font-medium text-lg" data-id="element-113">
            El sistema completo + los 6 bonos GRATIS
          </p>
        </div>

        <div className="bg-zinc-950/50 border border-zinc-800 rounded-2xl p-5 sm:p-6 mb-8" data-id="element-114">
          <ul className="space-y-3" data-id="element-115">
            <li className="flex items-start gap-3 text-zinc-200 text-sm sm:text-base" data-id="element-116">
              <BookOpen className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-117" />
              <span data-id="element-118">
                <strong className="text-white" data-id="element-119">10 Tomos completos</strong> de
                fuerza, potencia, acondicionamiento, movilidad y prevención de
                lesiones para BJJ y MMA.
              </span>
            </li>
            <li className="flex items-start gap-3 text-zinc-200 text-sm sm:text-base" data-id="element-120">
              <Gift className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-121" />
              <span data-id="element-122">
                <strong className="text-white" data-id="element-123">6 Bonos exclusivos</strong>{' '}
                <span className="text-amber-400" data-id="element-124">(GRATIS hoy)</span>:
                calculadoras en Excel, banco de calentamientos, recuperación,
                microciclo y movilidad express.
              </span>
            </li>
            <li className="flex items-start gap-3 text-zinc-200 text-sm sm:text-base" data-id="element-125">
              <Check className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-126" />
              <span data-id="element-127">
                <strong className="text-white" data-id="element-128">Acceso inmediato</strong> en PDF
                + planillas, para empezar hoy mismo.
              </span>
            </li>
          </ul>

          <div className="mt-5 pt-4 border-t border-zinc-800 flex items-center justify-between" data-id="element-129">
            <span className="text-zinc-400 text-sm sm:text-base" data-id="element-130">
              Valor real de todo el paquete
            </span>
            <span className="text-zinc-500 line-through font-display text-xl" data-id="element-131">
              $54.990
            </span>
          </div>
        </div>

        {/* Price */}
        <div className="flex flex-col items-center justify-center text-center mb-8" data-id="element-132">
          <span className="text-zinc-400 text-sm uppercase tracking-wider mb-1" data-id="element-133">
            Hoy lo conseguís por
          </span>
          <span className="text-zinc-500 line-through text-2xl md:text-3xl font-display mb-1" data-id="element-134">
            $54.990
          </span>
          <span className="text-6xl md:text-7xl font-display font-bold text-white drop-shadow-lg" data-id="element-135">
            $19.990 <span className="text-2xl text-zinc-400" data-id="element-136">ARS</span>
          </span>
        </div>

        <Button href={CHECKOUT_URL} fullWidth className="text-xl md:text-2xl py-6 mb-6" data-id="element-137">
          Quiero llegar al ultimo round
        </Button>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-zinc-400" data-id="element-138">
          <div className="flex items-center gap-2" data-id="element-139">
            <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-140" />
            <span data-id="element-141">Garantía de Satisfacción</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-142">
            <Lock className="w-5 h-5 text-zinc-300" data-id="element-143" />
            <span data-id="element-144">Pago 100% Seguro</span>
          </div>
        </div>
      </div>
    </section>;
}